import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from "recharts";

const COLORS = ["#00F0FF", "#00FF66", "#A78BFA", "#FF3366"];

export default function Reports() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then(r => setData(r.data)); }, []);
  if (!data) return <div className="label-mono text-cyan-300">CARGANDO...</div>;
  const byStatus = Object.entries(data.by_status).map(([k,v]) => ({ name: k, value: v }));

  return (
    <div data-testid="admin-reports">
      <header className="mb-8">
        <div className="label-mono mb-1">/ Reportes</div>
        <h1 className="font-display text-4xl chrome-text">Reportes & analítica</h1>
      </header>
      <div className="grid lg:grid-cols-2 gap-5">
        <div className="glass-card chrome-border p-6">
          <h3 className="font-tech text-white mb-4">Tráfico semanal</h3>
          <div className="h-72">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={data.daily}>
                <CartesianGrid stroke="#1f2937" strokeDasharray="3 3" />
                <XAxis dataKey="day" stroke="#6E7A94" />
                <YAxis stroke="#6E7A94" />
                <Tooltip contentStyle={{ background: "#0B0F17", border: "1px solid #2a3548", borderRadius: 8 }} />
                <Legend />
                <Bar dataKey="visits" fill="#00F0FF" radius={[6,6,0,0]} />
                <Bar dataKey="leads" fill="#00FF66" radius={[6,6,0,0]} />
                <Bar dataKey="whatsapp" fill="#A78BFA" radius={[6,6,0,0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="glass-card chrome-border p-6">
          <h3 className="font-tech text-white mb-4">Distribución de prospectos</h3>
          <div className="h-72">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={byStatus} dataKey="value" nameKey="name" outerRadius={100} label>
                  {byStatus.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Tooltip contentStyle={{ background: "#0B0F17", border: "1px solid #2a3548", borderRadius: 8 }} />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
      <div className="grid md:grid-cols-4 gap-4 mt-5">
        {[
          ["Visitas", data.totals.visits],
          ["Clics WhatsApp", data.totals.whatsapp_clicks],
          ["Prospectos", data.totals.leads],
          ["Prospectos 7 días", data.totals.leads_7d],
        ].map(([k,v]) => (
          <div key={k} className="glass-card chrome-border p-5">
            <div className="label-mono">{k}</div>
            <div className="font-display text-3xl chrome-text mt-1">{v ?? 0}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
